import { EntityModel } from '@/interfaces'
import {
  ALL_AGE_GROUP_SETTINGS_QUERY,
  CREATE_AGE_GROUP_SETTINGS_MUTATION,
  DELETE_AGE_GROUP_SETTINGS_MUTATION,
  FORCE_DELETE_AGE_GROUP_SETTINGS_MUTATION,
  SINGLE_AGE_GROUP_SETTINGS_QUERY,
  UPDATE_AGE_GROUP_SETTINGS_MUTATION,
} from './graphql'
import travelPricingAgeGroupEntity from '@/entities/travelPricingAgeGroup/entity'

const travelPricingAgeGroupSettingsModel: EntityModel = {
  name: 'ageGroupSettings',
  namePlural: 'ageGroupSettings',
  uniqueName: 'travelPricingAgeGroupSettings',
  uniqueNamePlural: 'travelPricingAgeGroupSettings',
  path: 'travel/pricing/age_group_settings',
  baseUrl: '/travel/pricing/age_group_settings',
  translationPrefix: 'entities:travelPricingAgeGroupSettings.',
  getDisplayName: (values: any) => {
    return 'Age Group Settings'
  },
  gql: {
    getAll: ALL_AGE_GROUP_SETTINGS_QUERY,
    getSingle: SINGLE_AGE_GROUP_SETTINGS_QUERY,
    create: CREATE_AGE_GROUP_SETTINGS_MUTATION,
    update: UPDATE_AGE_GROUP_SETTINGS_MUTATION,
    delete: DELETE_AGE_GROUP_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_AGE_GROUP_SETTINGS_MUTATION,
  },
  attributes: {
    freeUntilAge: {
      name: 'freeUntilAge',
      label: 'entities:travelPricingAgeGroupSettings.attributes.freeUntilAge.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    ageGroups: {
      name: 'ageGroups',
      label: 'entities:travelPricingAgeGroupSettings.attributes.ageGroups.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelPricingAgeGroupEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelPricingAgeGroupSettingsModel
